<ng-container *ngIf="isLoading$ | async">
   <ng-container *ngTemplateOutlet="searchIndicator"></ng-container>
</ng-container>

<ng-container *ngIf="!(isLoading$ | async)">
   <ng-container *ngIf="wasSearchingEverStarted$ | async; else initNewSearchInfo">
      <ng-container *ngTemplateOutlet="noSearchResultFound"></ng-container>
   </ng-container>
</ng-container>

<ng-template #initNewSearchInfo>
   <div *ngIf="noRecords">
      {{ 'common.no-records-available' | translate }}
   </div>
   <div *ngIf="!noRecords">
      {{ 'common.search_value_expected' | translate }}
   </div>
</ng-template>

<ng-template #noSearchResultFound>
   {{ 'common.no-search-result-found' | translate }}
</ng-template>

<ng-template #searchIndicator>
   <div class="lds-ripple">
      <div></div>
      <div></div>
   </div>
</ng-template>
